var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Access links"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h3", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading..."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized
                    ? _c("div", [
                        _c("table", { staticClass: "table table-hover" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.panelists, function (p) {
                              return _c("tr", { key: p.ProjectUserId }, [
                                _c("td", [
                                  _c("span", [_vm._v(_vm._s(p.Name))]),
                                  _c("br"),
                                  _vm._v(" "),
                                  p.HasEmail
                                    ? _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(p.Email))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !p.HasEmail
                                    ? _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [_vm._v("Email not provided")]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "align-middle" }, [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: p.AccessUrl,
                                          expression: "p.AccessUrl",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "text", readonly: "" },
                                      domProps: { value: p.AccessUrl },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            p,
                                            "AccessUrl",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary",
                                            attrs: {
                                              type: "button",
                                              title: "Copy to clipboard",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copyAccessUrlToClipboard(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-clipboard",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary",
                                            attrs: {
                                              type: "button",
                                              title: "Send link via email",
                                              disabled: !p.HasEmail,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.emailOne(p)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-regular fa-envelope",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { disabled: !_vm.initialized, type: "button" },
                      on: { click: _vm.downloadLinks },
                    },
                    [_vm._v("Download links")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { disabled: !_vm.initialized, type: "button" },
                      on: { click: _vm.emailAll },
                    },
                    [_vm._v("Email all")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [
          _vm._v(
            "\n                                        Panelist\n                                    "
          ),
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            "\n                                        Access link\n                                    "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }